import React, { useEffect, useState, createContext, useContext } from 'react';
import { UserRoles } from '../App';
import * as FeatureService from '../services/features';
interface FeatureContextType {
  hasAccess: (featureId: string) => boolean;
  useFeature: (featureId: string) => boolean;
  getRemainingUses: (featureId: string) => number;
  features: any[];
}
const FeatureContext = createContext<FeatureContextType>({
  hasAccess: () => false,
  useFeature: () => false,
  getRemainingUses: () => 0,
  features: []
});
export const useFeatures = () => useContext(FeatureContext);
export const FeatureProvider: React.FC<{
  children: React.ReactNode;
  userRole: string;
  features?: any[];
}> = ({
  children,
  userRole,
  features = []
}) => {
  const [featureState, setFeatureState] = useState<any[]>(features);
  // Initialize features with provided settings or defaults
  useEffect(() => {
    if (features.length > 0) {
      FeatureService.initializeFeatures(features);
      setFeatureState(features);
    }
  }, [features]);
  // Check if user has access to a feature
  const hasAccess = (featureId: string): boolean => {
    return FeatureService.hasFeatureAccess(featureId, userRole);
  };
  // Use a feature and return whether it was successful
  const useFeature = (featureId: string): boolean => {
    if (!hasAccess(featureId)) {
      return false;
    }
    // Record usage for free users with limits
    if (userRole === UserRoles.FREE) {
      FeatureService.recordFeatureUsage(featureId);
    }
    return true;
  };
  // Get remaining uses for a feature
  const getRemainingUses = (featureId: string): number => {
    return FeatureService.getRemainingUsage(featureId);
  };
  const value = {
    hasAccess,
    useFeature,
    getRemainingUses,
    features: featureState
  };
  return <FeatureContext.Provider value={value}>{children}</FeatureContext.Provider>;
};